/* Gray Market Airsoft — product-form.js
   PDP: qty stepper, variant switching, gallery thumb selection, tab switching */

(function () {
  'use strict';

  // ── Qty stepper ────────────────────────────────────────────────
  const qtyInput = document.getElementById('quantity');
  document.getElementById('qty-decrease')?.addEventListener('click', () => {
    if (qtyInput) qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1);
  });
  document.getElementById('qty-increase')?.addEventListener('click', () => {
    if (qtyInput) qtyInput.value = parseInt(qtyInput.value, 10) + 1;
  });

  // ── Gallery thumb selection ────────────────────────────────────
  const mainImg = document.getElementById('main-product-img');
  const counter = document.getElementById('gallery-counter');
  const thumbs = document.querySelectorAll('.gallery-thumb');
  const totalThumbs = thumbs.length;

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const idx = parseInt(thumb.dataset.index, 10);
      const src = thumb.dataset.src;
      if (mainImg && src) mainImg.src = src;
      if (counter) {
        const n = (idx + 1).toString().padStart(2, '0');
        const t = totalThumbs.toString().padStart(2, '0');
        counter.textContent = `VIEW ${n} / ${t}`;
      }
      thumbs.forEach(t => t.style.borderColor = 'var(--steel)');
      thumb.style.borderColor = 'var(--hazard)';
    });
  });

  // ── Variant selector ───────────────────────────────────────────
  const variantInputs = document.querySelectorAll('input[name^="options"]');
  const variantIdInput = document.getElementById('variant-id');
  const atcPriceEl = document.getElementById('atc-price');
  const atcBtn = document.getElementById('atc-main');

  // Highlight selected option labels
  function updateOptionUI() {
    document.querySelectorAll('[role="radiogroup"]').forEach(group => {
      const checked = group.querySelector('input[type="radio"]:checked');
      group.querySelectorAll('.variant-option').forEach(label => {
        const input = label.querySelector('input');
        const isSelected = input === checked;
        label.style.borderColor = isSelected ? 'var(--hazard)' : 'var(--steel)';
        label.style.background = isSelected ? 'var(--ink-2)' : 'transparent';
        label.style.color = isSelected ? 'var(--hazard)' : 'var(--bone)';
      });
      if (checked) {
        const labelSpan = group.closest('[style*="margin-bottom"]')?.querySelector('.selected-option-val');
        if (labelSpan) labelSpan.textContent = checked.value;
      }
    });
  }

  function updateAvailability() {
    const variantData = window.__variantData;
    if (!variantData) return;
    const groups = Array.from(document.querySelectorAll('[role="radiogroup"]'));
    groups.forEach((group, groupIdx) => {
      const otherSelections = groups
        .map((g, i) => ({ index: i, value: g.querySelector('input[type="radio"]:checked')?.value }))
        .filter(s => s.index !== groupIdx && s.value != null);
      group.querySelectorAll('.variant-option').forEach(label => {
        const value = label.querySelector('input')?.value;
        const reachable = variantData.some(v => {
          if (v.options[groupIdx] !== value) return false;
          return otherSelections.every(s => v.options[s.index] === s.value) && v.available;
        });
        label.classList.toggle('is-unavailable', !reachable);
      });
    });
  }

  variantInputs.forEach(input => {
    input.addEventListener('change', () => {
      updateOptionUI();
      updateAvailability();
      const selectedValues = Array.from(document.querySelectorAll('input[name^="options"]:checked')).map(i => i.value);
      const variantData = window.__variantData;
      if (!variantData) return;
      const match = variantData.find(v =>
        v.options.every((opt, i) => opt === selectedValues[i])
      );
      if (match) {
        if (variantIdInput) variantIdInput.value = match.id;
        if (atcPriceEl) atcPriceEl.textContent = formatMoney(match.price);
        if (atcBtn) atcBtn.disabled = !match.available;
      }
    });
  });

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  updateOptionUI();
  updateAvailability();

  // ── Tab switching ──────────────────────────────────────────────
  const tabBtns = document.querySelectorAll('.tab-btn');
  tabBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.tab;
      // Hide all panels
      document.querySelectorAll('[id^="tab-"]').forEach(panel => {
        panel.style.display = 'none';
      });
      // Show target
      const panel = document.getElementById('tab-' + target);
      if (panel) panel.style.display = 'block';
      // Update button styles
      tabBtns.forEach(b => {
        b.style.color = b === btn ? 'var(--hazard)' : 'var(--bone)';
        b.style.borderBottom = b === btn ? '2px solid var(--hazard)' : '2px solid transparent';
        b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
      });
      // Sync URL hash for sharability
      history.replaceState(null, '', '#' + target);
    });
  });

  // Restore tab from hash
  const hash = window.location.hash.replace('#', '');
  if (hash) {
    const matchingBtn = document.querySelector(`.tab-btn[data-tab="${hash}"]`);
    if (matchingBtn) matchingBtn.click();
  }

})();
